import integrationsClient, { type ApiDefinitions } from '@/tsClient/servers/governmentIntegrationsService';

type THIS_API = ApiDefinitions['/submission-attempts/{id}/messages/{messageId}']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getCaseSubmissionMessage = async ({ id, messageId }: Input): Promise<Output> => {
  const response = await integrationsClient.get(`/submission-attempts/${id}/messages/${messageId}`);
  return response.data;
};

export default getCaseSubmissionMessage;
